import { useMemo, useCallback, useImperativeHandle } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'

import {
  emailSelector,
  firstNameSelector,
  lastNameSelector,
  walletAddressSelector,
} from 'primsell-shared-layer/features'
import { RedeemActions } from 'features'

import { burnFormSchema } from './burn-form.validator'

import { IBurnFormProps, IBurnFormValues } from './burn-form.types'

const useBurnFormController = ({ formikRef, handleSubmit }: Omit<IBurnFormProps, 'actionText'>) => {
  const dispatch = useDispatch()

  const firstName = useSelector(firstNameSelector)
  const lastName = useSelector(lastNameSelector)
  const email = useSelector(emailSelector)
  const walletAddress = useSelector(walletAddressSelector)

  const INIT_VALUES: IBurnFormValues = useMemo(
    () => ({
      firstName: firstName ?? '',
      lastName: lastName ?? '',
      email: email ?? '',
      agree: true,
    }),
    [email, firstName, lastName]
  )

  const handleSubmitForm = useCallback(
    (formValues: IBurnFormValues) => {
      dispatch(RedeemActions.setBurnFormValues(formValues))
      handleSubmit()
    },
    [dispatch, handleSubmit]
  )

  const formik = useFormik({
    initialValues: INIT_VALUES,
    onSubmit: handleSubmitForm,
    validationSchema: burnFormSchema,
    validateOnMount: false,
    validateOnChange: false,
    validateOnBlur: false,
    enableReinitialize: true,
  })

  useImperativeHandle(formikRef, () => formik, [formik])

  const isFormDisabled = !walletAddress
  return { formik, isFormDisabled }
}

export { useBurnFormController }
